import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useQuery, useSubscription } from "@apollo/client";
import _ from "lodash";
import resultsUpdate from "../../helpers/resultsUpdate";
import Icons from "../../components/Icons";
import Section from "../../components/Section";
import { GET_FINALISTS, SUB_FINALIST } from "../../graphql_tags";

const SectionResults = styled(Section)`
  overflow: scroll;
  scroll-behavior: smooth;

  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  h3 {
    margin-top: 70px;
    margin-bottom: 0;
    font-weight: normal;
    font-size: 30px;
    line-height: 35px;

    color: #000000;
  }

  > div:nth-child(2) {
    display: flex;
    margin: 47px 0 11px 0;

    p {
      padding: 0 20px;
      width: 100%;
      display: flex;
      margin: 0;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;

      color: #777777;

      :nth-child(1) {
        max-width: 102px;
      }

      :nth-child(2) {
        max-width: 598px;
      }

      :nth-child(3),
      :nth-child(4),
      :nth-child(5) {
        max-width: 180px;
      }

      :not(:last-child) {
        margin-right: 3px;
      }
    }
  }
`;

const ResultsContainer = styled.div`
  margin-bottom: 100px;
`;

const FinishCard = styled.div`
  display: flex;

  div {
    padding: 17px 20px;
    width: 100%;
  }
`;

const FinishFinalist = styled(FinishCard)`
  height: 86px;

  :not(:last-child) {
    margin-bottom: 3px;
  }

  div {
    background-color: #ffffff;

    p {
      color: #000000;
    }

    :not(:last-child) {
      margin-right: 3px;
    }

    :nth-child(1) {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      max-width: 102px;
    }

    :nth-child(2) {
      max-width: 598px;

      p:last-child {
        color: #777777;
        margin-top: 3px;
        font-size: 17px;
      }
    }

    :nth-child(3),
    :nth-child(4),
    :nth-child(5) {
      max-width: 180px;
    }

    :nth-last-child(1) {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    p {
      font-weight: normal;
      font-size: 20px;
      line-height: 23px;
      margin: 0;
    }
  }
`;

export default () => {
  const loadFinalists = useQuery(GET_FINALISTS, { fetchPolicy: "no-cache" });
  const finalistUpdate = useSubscription(SUB_FINALIST);

  const [scores, setScores] = useState([]);
  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!loadFinalists.loading) {
      setScores(loadFinalists.data.finalists);
      setLoaded(true);
    }
  }, [loadFinalists.loading]);

  useEffect(() => {
    if (!finalistUpdate.loading && finalistUpdate.data.finalistUpdate) {
      resultsUpdate(finalistUpdate.data.finalistUpdate, scores, setScores);
    }
  }, [finalistUpdate.loading, finalistUpdate.data]);

  return (
    <SectionResults>
      <h3>
        Рейтинг финалистов городского конкурса профессионального мастерства
        «Московские мастера» в 2026 году по профессии «Библиотекарь»
      </h3>
      <div>
        <p>Место</p>
        <p>Финалист</p>
        <p>Общий балл I этапа</p>
        <p>Общий балл II этапа</p>
        <p>Общий балл III этапа</p>
        <p>Итоговый балл в Конкурсе</p>
      </div>
      <ResultsContainer>
        {isLoaded &&
          _.orderBy(scores, (obj) => +obj.total, "desc").map((item, i) => {
            const { id, name, library, stage_1, stage_2, stage_3, total } =
              item;
            const isNumStage = +stage_3 > 0;
            const isNumTotal = +total > 0;

            return (
              <FinishFinalist key={id}>
                <div>
                  <p>{i + 1}</p>
                </div>
                <div>
                  <p>{name}</p>
                  <p>{library}</p>
                </div>
                <div>
                  <p>{stage_1}</p>
                </div>
                <div>
                  <p>{stage_2}</p>
                </div>
                <div>
                  {isNumStage ? (
                    <p>{stage_3}</p>
                  ) : (
                    <Icons icon="iconClock" fill="#e4dada" />
                  )}
                </div>
                <div>
                  {isNumTotal ? (
                    <p>{total}</p>
                  ) : (
                    <Icons icon="iconClock" fill="#e4dada" />
                  )}
                </div>
              </FinishFinalist>
            );
          })}
      </ResultsContainer>
    </SectionResults>
  );
};
